import { getField, updateField } from 'vuex-map-fields';
import moment from 'moment';

const state = {
    fechaCreditoDebito: moment(new Date()).format('YYYY-MM-DD'),
    bancoCuentaId: 0,
    bancoCuenta: null,
    bancoCuentaNombre: null,
    bancoCuentaMonedaId: 0,
    bancoCuentaMoneda: null,
    importe: 0,
    
    chequeTerceroDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_TRANSFERENCIA'(state) {
        state.fechaCreditoDebito = moment(new Date()).format('YYYY-MM-DD');
        state.bancoCuentaId = 0;
        state.bancoCuenta = null;
        state.bancoCuentaNombre = null;
        state.bancoCuentaMonedaId = 0;
        state.bancoCuentaMoneda = null;
        state.importe = 0;
    },
    'SET_BANCO_CUENTA'(state, bancoCuenta) {
        state.bancoCuenta = bancoCuenta;

        if (bancoCuenta) {
            state.bancoCuentaId = bancoCuenta.id? bancoCuenta.id : 0;
            state.bancoCuentaNombre = bancoCuenta.nombre? bancoCuenta.nombre.trim() : null;
            state.bancoCuentaMonedaId = bancoCuenta.monedaId? bancoCuenta.monedaId : 0;
            state.bancoCuentaMoneda = bancoCuenta.moneda? bancoCuenta.moneda.trim() : null;
        } else {
            state.bancoCuentaId = 0;
            state.bancoCuentaNombre = null;
            state.bancoCuentaMonedaId = 0;
            state.bancoCuentaMoneda = null;
        }
    },
};

const getters = {
    getField,

    transferencia (state) {
        return {
            fechaCreditoDebito: moment(state.fechaCreditoDebito).format('YYYY-MM-DD'),
            bancoCuentaId: parseInt(state.bancoCuentaId),
            bancoCuenta: state.bancoCuenta,
            bancoCuentaNombre: state.bancoCuentaNombre,
            monedaId: parseInt(state.bancoCuentaMonedaId),
            moneda: state.bancoCuentaMoneda,
            importe: parseFloat(state.importe),
        }
    }
};

const actions = {
    inicializar ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_TRANSFERENCIA');
            resolve();
        }, error => {
            reject(error);
        })
    },
    setBancoCuenta: ({commit}, bancoCuenta) => {
        commit('SET_BANCO_CUENTA', bancoCuenta);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}